<template>
	<div class="page_account_header">
		<h2 class="page_account_header__title">{{ title }}</h2>
		<p class="page_account_header__desc">
			<slot v-if="$slots.desc" name="desc"></slot>
			<template v-else>{{ desc }}</template>
		</p>
	</div>
</template>

<script>
	export default {
		name: 'login-header',
		props: {
			title: {
				type: String,
				default: ''
			},
			desc: {
				type: String,
				default: ''
			}
		}
	};
</script>

<style scoped lang="less">
	.page_account_header {
		padding: 64px 0;
		.page_account_header__title {
			height: 67px;
			font-family: PingFangSC-Medium;
			font-size: 56px;
			font-weight: 500;
			line-height: 67px;
			color: #000;
		}
		.page_account_header__desc {
			margin-top: 26px;
			height: 34px;
			font-family: PingFangSC-Regular;
			font-size: 28px;
			font-weight: normal;
			line-height: 34px;
			color: #8F959E;
		}
	}
</style>
